import Icon from '../Icon';

const InfoIcon = (props) => {
    return (
        <Icon width='49' height='48' fill='none' {...props}>
            <circle cx='24.5' cy='24' r='22.75' stroke='#FFFDFB' strokeWidth='2.5' />
            <circle cx='24.5' cy='24' r='18.75' fill='#00D1D2' />
            <circle cx='24.5' cy='14.75' r='1.75' fill='#FFFDFB' />
            <rect x='23' y='19.4092' width='3' height='16' rx='1.5' fill='#FFFDFB' />
        </Icon>
    );
};

export default InfoIcon;
